import gql from "graphql-tag";

export const appVersions = gql`
  {
    appVersions {
      id
      type
      createDate
      version
      forceUpdate
      notes
    }
  }
`;

export const appVersion = gql`
  {
    appVersion {
      androidVersion
      androidForceUpdate
      iosVersion
      iosForceUpdate
    }
  }
`;

export const systemSettings = gql`
  {
    systemSettings {
      idReviewEmail
    }
  }
`;

const checkAppVersion = gql`
  query checkAppVersion($input: CheckAppVersionInput!) {
    checkAppVersion(input: $input)
  }
`;

export const addAppVersion = gql`
  mutation addAppVersion($input: AddAppVersionInput!) {
    addAppVersion(input: $input)
  }
`;

export const delAppVersion = gql`
  mutation delAppVersion($id: String!) {
    delAppVersion(id: $id)
  }
`;

export const saveSystemSettings = gql`
  mutation saveSystemSettings($input: FmSettingSystemInput!) {
    saveSystemSettings(input: $input)
  }
`;

export const settingGql = {
  appVersion,
  appVersions,
  addAppVersion,
  delAppVersion,
  checkAppVersion,

  systemSettings,
  saveSystemSettings,
};
